import type { ElementDescriptor } from '@/events/shared/ElementDescriptor';

/**
 * Descritor sanitizado para eventos de Viewport.
 *
 * Deliberadamente mais restrito que `describeElement` (usado por Click/Scroll):
 * sem texto, sem dataset e sem HTML — apenas identidade estrutural segura.
 */
export function describeViewportElement(
  element: Element | null
): ElementDescriptor | undefined {
  if (!element) return undefined;

  const classes = element.classList?.length
    ? Array.from(element.classList)
    : undefined;

  return {
    tagName: element.tagName ? element.tagName.toLowerCase() : undefined,
    id: element.id || undefined,
    classes,
    role: element.getAttribute('role') ?? undefined,
    name: element.getAttribute('name') ?? undefined,
  };
}
